// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, _, executeWpath, filterWpath;

  _ = require('lodash');

  Weaver = require('./Weaver');

  executeWpath = function(node, hops, res = [], trail = {}) {
    var binding, filter, hop, i, key, len, newRow, ref, ref1, results, row, to;
    newRow = function(blueprint) {
      var b, n, row;
      row = {};
      for (b in blueprint) {
        n = blueprint[b];
        row[b] = n;
      }
      return row;
    };
    [hop, ...hops] = hops;
    if (hop == null) {
      if (_.keys(trail).length > 0) {
        res.push(trail);
      }
      return;
    }
    [key, binding] = hop.split('?');
    // Optionally get the [] filter
    [key, filter] = key.split('[');
    if (filter != null) {
      ref = filter.split(']'), [filter] = ref;
    }
    if (!(node instanceof Weaver.ModelClass) || node.constructor.isAllowedRelation(key)) {
      ref1 = node.relation(key).all();
      results = [];
      for (i = 0, len = ref1.length; i < len; i++) {
        to = ref1[i];
        if (filterWpath(to, filter)) {
          row = newRow(trail);
          if (binding != null) {
            row[binding] = to;
          }
          results.push(executeWpath(to, hops, res, row));
        } else {
          results.push(void 0);
        }
      }
      return results;
    }
  };

  filterWpath = function(to, expr) {
    var action, condition, conditions, def, hasAnds, hasOrs, i, j, key, len, len1, met, ref, value;
    if (expr == null) {
      return true;
    }
    hasOrs = expr.indexOf('|') > -1;
    hasAnds = expr.indexOf('&') > -1;
    if (hasOrs && hasAnds) {
      throw new Error("Wpath does not support combination of AND and OR");
    }
    value = !hasOrs;
    conditions = [expr];
    if (hasOrs) {
      conditions = expr.split('|');
    }
    if (hasAnds) {
      conditions = expr.split('&');
    }
    for (i = 0, len = conditions.length; i < len; i++) {
      condition = conditions[i];
      met = void 0;
      [action, key] = condition.split('=');
      switch (action.trim()) {
        case 'id':
          met = to.id() === key;
          break;
        case 'class':
          met = false;
          if (to.model != null) {
            ref = to.relation(to.model.getMemberKey()).all();
            for (j = 0, len1 = ref.length; j < len1; j++) {
              def = ref[j];
              met |= def.id() === key;
            }
          }
          break;
        default:
          throw new Error(`Key ${action} not supported in wpath`);
      }
      if (hasOrs) {
        value |= met;
      } else {
        value &= met;
      }
    }
    return value;
  };

  module.exports = {
    wpath: function(node, expr = '', func, load = false) {
      var hops, i, len, res, row;
      hops = expr.split('/');
      if (hops[0] === '') {
        hops.splice(0, 1);
      }
      res = [];
      executeWpath(node, hops, res);
      if (func != null) {
        for (i = 0, len = res.length; i < len; i++) {
          row = res[i];
          func(row);
        }
      }
      return res;
    }
  };

}).call(this);
